import React from 'react'

export default function H4(props) {
  const {children, className = ''} = props
  
  return (
    <h4 className={`text-base lg:text-lg font-semibold lg:font-bold ${className}`}>{children}</h4>
  )
}
